<div class="color_container">
  @for (color of colors; track color) {
    <div
      class="color_circle"
      [style]="'backgroundColor:#' + (color ? color.color : 'fff')">
    </div>
  }
</div>
